import * as SwitchPrimitive from "@radix-ui/react-switch";
import { forwardRef } from "react";
import { cn } from "@/lib/utils";

export const Switch = forwardRef<
  React.ComponentRef<typeof SwitchPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitive.Root
    ref={ref}
    className={cn(
      "peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent",
      "transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime-dk focus-visible:ring-offset-2",
      "disabled:cursor-not-allowed disabled:opacity-50",
      // The OFF track was `bg-ink-200`, which is not a token: the `ink` scale in
      // tailwind.config.ts defines 900/700/500/300/100/050 and nothing else, so
      // that class emitted no CSS at all and the track rendered transparent —
      // an invisible control on any white card. `ink-300` is the darkest shade
      // that still reads as "off" rather than "filled", and it is a real token.
      "data-[state=checked]:bg-lime data-[state=unchecked]:bg-ink-300",
      className,
    )}
    {...props}
  >
    <SwitchPrimitive.Thumb
      className={cn(
        "pointer-events-none block h-4 w-4 rounded-full bg-white shadow-sm ring-0",
        "transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0",
      )}
    />
  </SwitchPrimitive.Root>
));
Switch.displayName = SwitchPrimitive.Root.displayName;
